module.exports = __webpack_public_path__ + "img/NO937896670.af842141.png";